import { DialogContent } from "@mui/material";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { BottomSheet, Text, type UseModalState } from "@src/appV2/redesign/system/ui-components";

interface InfoBottomSheetProps {
  modalState: UseModalState;
}

const INFO_TEXT =
  "This is the total sum of bonus payments that you've earned. Your bonus gets paid once a workplace signs up with your affiliate link and their first shift is completed.";

export function EarningsInfoBottomSheet(props: InfoBottomSheetProps) {
  const { modalState } = props;

  return (
    <BottomSheet
      canDismiss
      modalState={modalState}
      header={
        <BottomSheetHeader
          onClose={() => {
            modalState.closeModal();
          }}
        />
      }
    >
      <DialogContent>
        <Text variant="body1" paddingY={4}>
          {INFO_TEXT}
        </Text>
      </DialogContent>
    </BottomSheet>
  );
}
